import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dashboardService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as settingsActions from './actions';

export function fetchSettings(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_SETTINGS),
    mergeMap(({ payload }) => {
      return dashboardService.getSettings(payload)
        .pipe(
          map(res => settingsActions.fetchSettingsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}